import React from "react";
import { CustomFieldEditProps } from "../contracts";
import { Button, Icon, Typography } from "@fox/atoms";
import { FieldFlexWrapper } from "../fields";

export const CheckboxCustomField: React.FC<CustomFieldEditProps> = ({ customField, onChange }) => {
	const UNCHECKED_VALUE = "0";
	const CHECKED_VALUE = "1";

	return (
		<FieldFlexWrapper>
			<Typography  color="text.disabled">{customField.displayName}</Typography>
			{customField.value === CHECKED_VALUE ? (
				<Button
					fullWidth
					onClick={(e) => {
						onChange(customField.customFieldId, UNCHECKED_VALUE);
					}}
					startIcon={<Icon iconName="Done" color="success" />}
				/>
			) : (
				<Button
					fullWidth
					onClick={(e) => {
						onChange(customField.customFieldId, CHECKED_VALUE);
					}}
					startIcon={<Icon iconName="Cancel" color="error" />}
				/>
			)}
		</FieldFlexWrapper>
	);
};
